import { Component } from '@angular/core';

@Component({
  selector: 'proffeo-project',
  templateUrl: './project-details-view.component.html'
})
export class ProjectDetailsViewComponent {}
